import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "lego-color-picker" }
const _hoisted_2 = { class: "native-color-container" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "picked-color-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "color-item transparent-back"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "color",
        value: _ctx.value,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange(($event.target as HTMLInputElement)?.value)))
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (item, key) => {
        return (_openBlock(), _createElementBlock("li", {
          key: key,
          class: _normalizeClass(`item-${key}`),
          onClick: _withModifiers(($event: any) => (_ctx.onChange(item)), ["prevent"])
        }, [
          (item.startsWith('#'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle({ backgroundColor: item }),
                class: "color-item"
              }, null, 4))
            : (_openBlock(), _createElementBlock("div", _hoisted_6))
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}